import './App.css';
import { useState } from 'react';
import { Input, Button, Card } from "antd";
import { hashSHA256 } from "./utils/hash";

export default function SearchGoogleSheet() {
  const [name, setName] = useState("");
  const [birth, setBirth] = useState("");
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const SHEET_ID = process.env.REACT_APP_SHEET_ID;
  const API_KEY = process.env.REACT_APP_API_KEY;
  const RANGE = "A:F"; // A: name, B: birth, C: other, D: result

  
  const handleSearch = async () => {
    setLoading(true);
    setResult(null);

    try {

      const nameBirthHash = await hashSHA256(name + birth);

      const url = `https://sheets.googleapis.com/v4/spreadsheets/${SHEET_ID}/values/${RANGE}?key=${API_KEY}`;
      const response = await fetch(url);
      const data = await response.json();

      if (!data.values) {
        console.log(data);
        setResult("데이터 없음");
        return;
      }

      console.log(data.values);
      console.log(nameBirthHash);

      const found = data.values.find((row) => row[4] === nameBirthHash);

      if (found) {
        setResult(found[5]); // result 값 표시
      } else {
        setResult("일치하는 데이터 없음");
      }
    } catch (error) {
      console.error("검색 오류:", error);
      setResult("오류 발생");
    } finally {
      setLoading(false);
    }
  };

  // Commented out hash download functionality
  /*
  const downloadHashedCSV = async () => {
    setLoading(true);
    try {
      const url = `https://sheets.googleapis.com/v4/spreadsheets/${SHEET_ID}/values/${RANGE}?key=${API_KEY}`;
      const response = await fetch(url);
      const data = await response.json();

      if (!data.values) {
        console.log("No data found");
        return;
      }

      // 각 행의 name과 birth를 해시화
      const hashedRows = await Promise.all(
        data.values.map(async (row) => {
          const name = row[2];
          const birth = row[3];
          const hash = await hashSHA256(name + birth);
          return [name, birth, hash];
        })
      );

      // CSV 문자열 생성
      const csvContent = "Name,Birth,Hash\n" + 
        hashedRows.map(row => row.join(",")).join("\n");

      // CSV 파일 다운로드
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "hashed_data.csv";
      link.click();
    } catch (error) {
      console.error("CSV 생성 오류:", error);
    } finally {
      setLoading(false);
    }
  };
  */

  return (
    <div className="h-screen justify-center flex flex-col items-center gap-4 p-4">
      <Card className="w-96 p-4">
        <h2 className="text-xl font-semibold mb-4">2025 전주송북초 학급 편성</h2>
        <Input
          placeholder="홍길동"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <Input
          placeholder="240101"
          value={birth}
          onChange={(e) => setBirth(e.target.value)}
          className="mt-2"
        />
        <Button
          type="primary"
          onClick={handleSearch}
          className="mt-4 w-full"
          loading={loading}
        >
          검색
        </Button>
        {/* Commented out download button
        <Button
          onClick={downloadHashedCSV}
          className="mt-2 w-full"
          loading={loading}
        >
          해시 데이터 다운로드
        </Button>
        */}

        {result && (
          <Card className="mt-4 p-4 bg-gray-100">
            <h3 className="font-semibold">검색 결과:</h3>
            <p>{result}</p>
          </Card>
        )}
      </Card>
      <div className="text-sm text-gray-500">
        <p>
          이 페이지는 2025. 3. 4.까지 임시 운영됩니다. 
        </p>
      </div>
    </div>
  );
}